import { createContext, useContext, useState } from "react";
import { AutoTaskAuthContext } from "../../../Context/AutoTaskContext";

const ATSContext = createContext();

export const useATS = () => {
  const context = useContext(ATSContext);
  if (!context) throw new Error("useATS must be used within ATSProvider");
  return context;
};

export const ATSProvider = ({ children }) => {
  const { userInfo } = useContext(AutoTaskAuthContext) || {};
  const user_id = userInfo?.id;
  const store_id = userInfo?.store_id;
  const validStoreId =
    store_id === undefined || store_id === null ? undefined : store_id;
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const triggerRefresh = () => setRefreshTrigger((prev) => prev + 1);

  return (
    <ATSContext.Provider
      value={{
        store_id: validStoreId,
        user_id: user_id,
        refreshTrigger,
        triggerRefresh,
      }}
    >
      {children}
    </ATSContext.Provider>
  );
};
